var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 723,
    height: 527,
    viewBox: "0 0 723 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M345.5 60L308.493 21.597C298.063 10.7726 284.674 3.26095 270 0V118L314.5 106L345.5 60Z",
    fill: "#0A58CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.541 59H376V110H270L273.396 108.688C285.678 103.943 296.901 96.8188 306.423 87.7252L322.007 72.8414C331.309 63.9573 343.678 59 356.541 59Z",
    fill: "#0D6EFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 110H723V511C723 519.837 715.837 527 707 527H16C7.16344 527 0 519.837 0 511V110Z",
    fill: "#0D6EFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M376 59H691C708.673 59 723 73.3269 723 91V110H376V59Z",
    fill: "#0D6EFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32C0 14.3269 14.3269 0 32 0H270V110H0V32Z",
    fill: "#0A58CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.40f307ec3b351c16e18a4cbc8b426322.svg";
export { ForwardRef as ReactComponent };